import React, { useContext, useEffect, useState } from 'react';
import { Context } from '@routes/private/Editor/Context';
import { IProps } from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import FlipIcon from '@assets/icons/flipIcon';
import ToolTip from '@components/Tooltip';
import { findElementById } from "@utils/editor";

const FlipCommandOption : React.FC<IProps> = () => {
  const context = useContext(Context);
  const [open, setOpen] = useState(false);
  const [flipX, setFlipX] = useState(false);
  const [flipY, setFlipY] = useState(false);

  useEffect(() => {
    setFlipX(context.editorStatus.selectedElementsId.every((idElement) => {  
        const element = findElementById(context.data, idElement);
        if (element && element.type==="Image") {
          if (element?.attributes.flip && element.attributes.flip.substr(0, 1) === '1') {
            return true;
          }
          return false;
        }
        return true;
      }));
    setFlipY(context.editorStatus.selectedElementsId.every((idElement) => {  
        const element = findElementById(context.data, idElement);
        if (element && element.type==="Image") {
          if (element?.attributes.flip && element.attributes.flip.substr(1, 2) === '1') {
            return true;
          }
          return false;
        }
        return true;
    }));
  }, [context.editorStatus.selectedElementsId.length, context.editorStatus.selectedElementsId[0], context.data]);

  const handleChangeFlip = (action: string) => {
    let elementsIds: string[] = [];
    let values: string[] = [];
    context.editorStatus.selectedElementsId.map((idElement) => {  
      const element = findElementById(context.data, idElement);
      if (element && element.type=="Image") {
        let flip: string = '00';
        if (element.attributes.flip) {
          const flipXValue = element.attributes.flip.substr(0, 1);
          const flipYValue = element.attributes.flip.substr(1, 2);
          if (action === 'horizontal') {
            flip = `${flipXValue === '1' ? '0' : '1'}${flipYValue}`;
          } else {
            flip = `${flipXValue}${flipYValue === '1' ? '0' : '1'}`;
          }
        } else {
          if (action === 'horizontal') {
            flip = '10';
          } else {
            flip = '01';
          }
        }
        elementsIds.push(idElement);
        values.push(flip);
      }
    });
    context.onCommandChange('flip', undefined, elementsIds, values);
}

  const handleOpen = () => {
    setOpen(!open);
  }

  return (
    <S.Root>
      <ToolTip
        tip="Flip"
      >
        <S.IconContainer
          onClick={handleOpen}
          backgroundColorValue={open ? C.DARK_BLUE : 'auto'}
        >
          <FlipIcon style={{fillColor: C.GENERIC_GRAY}} />
        </S.IconContainer>
      </ToolTip>
      { open && 
        <S.OptionsContainer>
          <S.RowContainer>
            <S.IconList 
              rotationValue={'-90'}
              backgroundColorValue={flipY ? 'rgba(18, 36, 66, 0.1)' : 'auto'}
              onClick={() => handleChangeFlip('vertical')}
            >
              <FlipIcon />
            </S.IconList>
            <S.Text>
              Flip Vertical
            </S.Text>
          </S.RowContainer>
          <S.RowContainer>
            <S.IconList
              rotationValue={'0'}
              backgroundColorValue={flipX ? 'rgba(18, 36, 66, 0.1)' : 'auto'}
              onClick={() => handleChangeFlip('horizontal')}
            >
              <FlipIcon />
            </S.IconList>
            <S.Text>
              Flip Horizontal
            </S.Text>
          </S.RowContainer>
        </S.OptionsContainer>
      }
    </S.Root>
  );
}

export default FlipCommandOption;